import Typography from './Typography';

export * from './types';

export default Typography;
